import { useMemo } from 'react';

import uniq from 'lodash/uniq';
import { FilterSelect, useSearchContext } from '@cast/shared-search-ui';

import { Cluster } from '@cast/types';
import { Box } from '@cast/design-system';

type ProviderFilterProps = {
  fullWidth?: boolean;
};

export const ProviderFilter = ({ fullWidth }: ProviderFilterProps) => {
  const searchCtx = useSearchContext<Cluster>();

  const options = useMemo(
    () =>
      uniq(
        (searchCtx?.data
          ?.map((cluster) => cluster.providerType)
          .filter((provider) => !!provider) as string[]) || []
      ),
    [searchCtx?.data]
  );

  return (
    <Box sx={fullWidth ? { width: '100%' } : undefined}>
      <FilterSelect
        criterion="provider"
        options={options}
        SelectProps={{ inputText: 'Provider', size: 'md' }}
        multiple
        sx={{ width: '100%' }}
        testId="clusters-provider-filter"
      />
    </Box>
  );
};
